export interface ReminderPush {
  title: string;
  body: string;
  url: string;
  tag: string;
}

/** The token the server keeps verbatim; the device fills in its own calendar day when the notification is tapped. */
export const TODAY_TOKEN = "{today}";

export function parsePush(raw: string | null | undefined): ReminderPush | null {
  if (!raw) return null;
  try {
    const value = JSON.parse(raw) as Partial<ReminderPush>;
    if (typeof value.title !== "string" || typeof value.body !== "string") return null;
    return { title: value.title, body: value.body, url: typeof value.url === "string" ? value.url : "/", tag: typeof value.tag === "string" ? value.tag : "reminder" };
  } catch {
    return null;
  }
}

/** Replaces the day token with the device's local date, YYYY-MM-DD. */
export function resolveReminderUrl(url: string, now: Date): string {
  const day = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  return url.replaceAll(TODAY_TOKEN, day);
}
